module.exports = __webpack_public_path__ + "static/media/194-malta.39006a5e.svg";